// extracted by mini-css-extract-plugin
export var closeButton = "_je-1";
export var closeX = "_je-3";
export var container = "_je-0";
export var image = "_je-2";